<template>
    <div class="float-left col text-muted p-item mb-2">
        <small>{{ getControlLabel(control.name) }}</small><br>
        <template v-if="control.status == 'CURRENT'">
            <b>{{ getControlValue(control.name, control.value) }}</b>
        </template>
        <template v-if="control.status == 'NEW'">
            <b class="added">{{ getControlValue(control.name, control.value) }}</b>
        </template>
        <template v-if="control.status == 'UPDATE'">
            <ul>
                <li class="added">
                    <b class="added">{{ getControlValue(control.name, control.value) }}</b>
                </li>
                <li class="deleted">
                    <b class="deleted">{{ getControlValue(control.name, control.old) }}</b>
                </li>
            </ul>
        </template>
        <template v-else>
            <b class="deleted">{{ getControlValue(control.name, control.old) }}</b>
        </template>
    </div>
</template>

<script>
import Utils from '@/common/utils'

export default {
    name: 'AuditNoteHeader',

    props: {
        control: Object
    },

    data() {
        return {
            dictionary: [
                { name: 'LastEditDate', type: 'date', caption: 'LastEditDate' },
                { name: 'Servicedate', type: 'date', caption: this.$t('MdNote.Service') },
                { name: 'Signeddate', type: 'date', caption: this.$t('MdNote.SignedOn') },
                { name: 'IsPendingSignature', type: 'boolean', caption: 'IsPendingSignature' },
                { name: 'Issigned', type: 'boolean', caption: 'Issigned' }
            ]
        }
    },

    methods: {
        getControlLabel(controlName) {
            const control = this.dictionary.find(x => x.name == controlName);
            if (control) {
                return control.caption
            }
                
            return controlName;
        },

        getControlValue(controlName, controlValue) {
            const control = this.dictionary.find(x => x.name == controlName);
            if (control) {
                if (control.type == 'date') {
                    return Utils.formatterDateTimeToString(controlValue, 'MM/DD/YYYY hh:mm:ss');
                }
                return controlValue
            }
                
            return controlValue;
        }
    }
}
</script>

<style scoped>
.deleted {
    color: red !important;
}
.added {
    color: green !important;
}
.b-2 {
    border: 2px solid !important;
}
</style>